import { FC } from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { Box } from '@mui/material'

import GRCircularProgress from '../GRCircularProgress/GRCircularProgress'
import './GRMarkdown.scss'

type GRMarkdownProps = {
  text: string
  isTyping?: boolean
}

export const GRMarkdown: FC<GRMarkdownProps> = ({ text, isTyping }) => {
  return (
    <div className="GRMarkdown">
      <Markdown remarkPlugins={[remarkGfm]}>{text}</Markdown>
      {isTyping && (
        <Box my={2}>
          <GRCircularProgress mt={3} circularProgressProps={{ size: 16 }} />
        </Box>
      )}
    </div>
  )
}
